/** Locale catalog without message JSON — safe to import from middleware. */

export type SupportedLocale = "en" | "pl" | "es" | "de" | "zh" | "fr" | "nl" | "it" | "ru";

/** All locales known to routing / types. */
export const LOCALES: SupportedLocale[] = ["en", "de", "es", "fr", "nl", "pl", "zh", "it", "ru"];

/**
 * Locales shown in the language switcher, sitemap, hreflang, and Accept-Language redirects.
 */
export const PUBLIC_LOCALES: SupportedLocale[] = ["en", "de", "es", "fr", "nl", "pl", "zh", "it", "ru"];

export const HIDDEN_LOCALES: SupportedLocale[] = [];

export const DEFAULT_LOCALE: SupportedLocale = "en";

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}

export function isPublicLocale(value: unknown): value is SupportedLocale {
  return typeof value === "string" && (PUBLIC_LOCALES as readonly string[]).includes(value);
}

export function isHiddenLocale(value: unknown): value is SupportedLocale {
  return typeof value === "string" && (HIDDEN_LOCALES as readonly string[]).includes(value);
}
